import React, { useEffect, useState, lazy, useContext } from "react";
import * as Sentry from "@sentry/react";
import { RouteChangeScrollToTop } from "manifest-components/src/utils/scrollToTop";
import { Route, Routes, useLocation } from "react-router-dom";
import Authentication from "../utils/authentication";
import NonAuthRoutes from "./NonAuthRoutes";
import { VersionContext } from "../context/Version/versionProvider";

const AuthRoutes = lazy(() => import("./AuthRoutes"));

export default function AppRoutes() {
  const location = useLocation();
  const { initialVersion } = useContext(VersionContext);
  const [isVerified, setIsVerified] = useState(Authentication.verify());

  const isSentryInitialized = () => {
    const sentryClient = Sentry.getCurrentHub().getClient();
    return sentryClient !== null && sentryClient !== undefined;
  };

  useEffect(() => {
    setIsVerified(Authentication.verify());
  }, [location.pathname]);

  useEffect(() => {
    if (!isSentryInitialized() || !initialVersion) return;
    Sentry.setContext("app", {
      version: initialVersion,
    });
  }, [isSentryInitialized, initialVersion]);

  return (
    <Routes>
      <Route
        path="*"
        element={
          <>
            <RouteChangeScrollToTop />
            {isVerified ? <AuthRoutes /> : <NonAuthRoutes />}
          </>
        }
      />
    </Routes>
  );
}
